import React from "react";

import './index.scss';

interface IProps {
  children?: any
  className?: string
  type?: '1' | '2'
}

const Title = (props: IProps) => {
  const { children, className,type = '2' } = props;
  return (
    <span className={`pit-title ${className} tag-${type}`}>{children}</span>
  )
}

export default Title;
